import { useState, useEffect, useContext } from "react";
import { useNavigate, useParams } from "react-router-dom";

//graphql
import { useQuery, useMutation, ApolloError } from "@apollo/client";
import { GET_JOBS, SET_JOB } from "../queries";

//material-ui
import { Alert, AppBar, Toolbar, Typography, IconButton } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";

//providers
import { useSnacks } from "../providers/SnackProvider";
import { MqttContext } from "../providers/MqttProvider";

//ag-grid
import { AgGridReact } from "ag-grid-react";

//helpers
import HandleApolloError from "../helpers/HandleApolloError";

import { ModuleRegistry, AllCommunityModule } from "ag-grid-community";

ModuleRegistry.registerModules([AllCommunityModule]);

const Jobs = () => {
	let { id } = useParams();
	let DeviceID = Number(id);

	const navigate = useNavigate();

	const [agHeight, setAgHeight] = useState(100);
	const [openSnack] = useSnacks();

	const { mqttPublish } = useContext(MqttContext);

	const postCompleted = async (d: any) => {
		console.log("Select Job Completed", d);
		let topic = "/countc/" + id + "/command";
		mqttPublish(topic, '{"cmdType":"resetCount"}', { retain: false });
		navigate("/counter/" + DeviceID);
	};

	const jobError = (error: ApolloError) => {
		let errs = HandleApolloError("Selecting Job", error);
		for (let err of errs) {
			openSnack(err, "error", true);
		}
	};

	const [setJob] = useMutation(SET_JOB, {
		onCompleted: postCompleted,
		onError: jobError,
		//ignoreResults: true,
		refetchQueries: ["GetDevice"],
	});

	const updateAgHeight = () => {
		setAgHeight(window.innerHeight);
	};

	const handleSelectJob = (d: any) => {
		setJob({ variables: { input: { DeviceID: DeviceID, JobID: Number(d.data.JobID), AllottedMinutes: d.data.AllottedMinutes } } });
	};

	function remainingQuantity(params: any) {
		return params.data.Quantity - params.data.CompletedQuantity;
	}

	function remainingQuantityFormat(params: any) {
		return params.value < 0 ? "(" + params.value + ")" : params.value;
	}

	useEffect(() => {
		updateAgHeight();
		//causing rerender on some devices when keyboard is shown
		// window.addEventListener("resize", updateAgHeight);
	}, []);

	const gridData = {
		columnDefs: [
			{ headerName: "JobID", field: "JobID", sortable: true, filter: true, floatingFilter: true },
			{ headerName: "Size", field: "Size", sortable: true, filter: true, floatingFilter: true },
			{ headerName: "Botanical", field: "Botanical", sortable: true, filter: true, floatingFilter: true },
			{ headerName: "StartWeek", field: "StartWeek", sortable: true, filter: true, floatingFilter: true },
			{ headerName: "ReadyWeek", field: "ReadyWeek", sortable: true, filter: true, floatingFilter: true },
			{ headerName: "Qty Needed", valueGetter: remainingQuantity, valueFormatter: remainingQuantityFormat, sortable: true, filter: true, floatingFilter: true },
			{ headerName: "Qty Planned", field: "Quantity", sortable: true, filter: true, floatingFilter: true },
			{ headerName: "Qty Produced", field: "CompletedQuantity", sortable: true, filter: true, floatingFilter: true },
		],
	};

	function handleClose() {
		navigate("/counter/" + DeviceID);
	}

	const { data, loading, error } = useQuery(GET_JOBS, { fetchPolicy: "network-only" });
	if (error) return <Alert severity="error">JOBS ERROR: {error.message}</Alert>;

	return (
		<>
			<AppBar id="jobHeader">
				<Toolbar>
					<IconButton edge="start" color="inherit" onClick={handleClose} aria-label="close">
						<CloseIcon />
					</IconButton>
					<Typography variant="h6">Select Job</Typography>
				</Toolbar>
			</AppBar>
			{loading ? (
				<div>loading</div>
			) : (
				<div className="ag-theme-alpine" id="count-jobs-grid" style={{ width: "100%", paddingTop: "68px", height: `${agHeight}px` }}>
					<AgGridReact columnDefs={gridData.columnDefs} rowData={data.countcJobs} onRowClicked={(d) => handleSelectJob(d)} />
				</div>
			)}
		</>
	);
};

export default Jobs;
